import { render, staticRenderFns } from "./linkManager.vue?vue&type=template&id=2be80278&"
import script from "./linkManager.vue?vue&type=script&lang=js&"
export * from "./linkManager.vue?vue&type=script&lang=js&"
import style0 from "./linkManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports